import $ from "../../libs/jquery-3.3.1.min.js"
import {gsap} from "../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras'
import {BaseMiniGame} from "./BaseMiniGame";


// Game description : Texte troué - drag and drop tags in zones
export class GameF extends BaseMiniGame {

  // Constructor
  constructor(data) {
    super(data);
    this.appWidth = this.data.appDimensions.width;
    this.appHeight = this.data.appDimensions.height;
    this.tagWidth = this.data.tagsSize.width;
    this.tagHeight = this.data.tagsSize.height;

    this.textPadding = 40;
    this.textMargin = 80;
    this.verticalMarginBetween = 20;
    this.tagSpaceBetweenX = 20;
    this.tagSpaceBetweenY = 25;

    this.dragTarget = false;
    this.tagsObjects = [];
    this.isCheckingAnswer = false;
    this.foundAnswers = 0;

    // Question text style
    this.questionTextStyle = new PIXI.TextStyle({
      align: "center",
      fill: "#000000",
      fontFamily: "Helvetica",
      fontSize: 24,
      wordWrap: true,
      wordWrapWidth: this.appWidth * 0.8
    });

    // Sentence text style
    this.sentenceTextStyle = new PIXI.TextStyle({
      align: "left",
      fill: "#000000",
      fontFamily: "Helvetica",
      fontSize: 24,
      wordWrap: true,
      lineHeight: 42,
      wordWrapWidth: this.appWidth - (this.textMargin * 2) - (this.textPadding * 2)
    });

    // Tag text style
    this.tagTextStyle = new PIXI.TextStyle({
      align: "center",
      fill: "#000000",
      fontFamily: "Helvetica",
      fontSize: 24,
      wordWrap: true,
      wordWrapWidth: this.tagWidth - 20
    });
  }

  async assetLoader() {
    await super.assetLoader();

    if (this.data.medias && this.data.medias.length) {
      for (let i = 0; i < this.data.medias.length; i++) {
        this.assets[this.data.medias[i].name] = await PIXI.Assets.load(this.data.medias[i].url);
      }
    }
  }

  async buildStage() {

    // Enable events on the whole stage
    this.stage.hitArea = this.screen;

    // DEV - UNCOMMENT TO GET DROPZONE LOCATIONS
    // Click in the middle of the word to get X/Y positions
    // this.stage.eventMode = 'static';
    // this.stage.on("click", (e) => {
    //   console.log("CLICK", this.sentenceTextContainer.toLocal(e.global, null))
    // });

    // Prepare question
    this.questionTextContainer = new PIXI.Container();
    this.questionTextContainer.position.x = 0;
    this.questionTextContainer.position.y = 0;
    this.stage.addChild(this.questionTextContainer);

    this.questionBackground = new PIXI.Sprite(this.assets["question_background_bubble"]);
    this.questionTextContainer.addChild(this.questionBackground);

    this.questionTextEN = this.createInterfaceText(this.data.question["en"], this.questionTextStyle, "en");
    this.questionTextFR = this.createInterfaceText(this.data.question["fr"], this.questionTextStyle, "fr");
    this.questionTextEN.anchor.set(0.5); // center in box easier
    this.questionTextFR.anchor.set(0.5); // center in box easier
    this.questionTextEN.position.x = this.questionTextContainer.width / 2;
    this.questionTextFR.position.x = this.questionTextContainer.width / 2;
    this.questionTextEN.position.y = this.questionTextContainer.height / 2;
    this.questionTextFR.position.y = this.questionTextContainer.height / 2;

    this.questionTextContainer.addChild(this.questionTextEN);
    this.questionTextContainer.addChild(this.questionTextFR);

    // Prepare sentence container
    this.sentenceTextContainer = new PIXI.Container();
    this.sentenceTextContainer.position.x = this.textMargin;
    this.sentenceTextContainer.position.y = this.questionTextContainer.position.y + this.questionTextContainer.height;
    this.stage.addChild(this.sentenceTextContainer);

    // Prepare sentence text
    this.sentenceTextEN = this.createInterfaceText(this.data.sentence.en, this.sentenceTextStyle, "en");
    this.sentenceTextFR = this.createInterfaceText(this.data.sentence.fr, this.sentenceTextStyle, "fr");
    this.sentenceTextEN.position = {x: this.textPadding, y: this.textPadding};
    this.sentenceTextFR.position = {x: this.textPadding, y: this.textPadding};

    // Prepare sentence background
    this.sentenceBackgroundSprite = new PIXI.Sprite(PIXI.Texture.WHITE);
    this.sentenceBackgroundSprite.width = this.appWidth - (this.textMargin * 2);
    this.sentenceBackgroundSprite.height = this.sentenceTextFR.height + (this.textPadding * 2);
    this.sentenceTextContainer.addChild(this.sentenceBackgroundSprite);

    this.sentenceTextContainer.addChild(this.sentenceTextEN);
    this.sentenceTextContainer.addChild(this.sentenceTextFR);

    // Prepare choices
    this.tagsContainer = new PIXI.Container();
    this.tagsContainer.position.y = this.sentenceTextContainer.position.y + this.sentenceTextContainer.height + this.verticalMarginBetween;
    this.stage.addChild(this.tagsContainer);

    let tagIndex = 0;
    for (let row = 0; row < 3; row++) {
      for (let column = 0; column < 4; column++) {
        if (this.data.tags[tagIndex]) {
          let tagContainer = new PIXI.Container();
          tagContainer.eventMode = "static";
          tagContainer.tagValue = tagIndex;

          // tag background
          let tagBg = new PIXI.Sprite(PIXI.Texture.WHITE);
          tagBg.width = this.tagWidth;
          tagBg.height = this.tagHeight;
          tagBg.position.x = 0;
          tagBg.position.y = 0;
          tagContainer.addChild(tagBg);

          // set position
          tagContainer.position.x = ((column % 4) * tagBg.width) + ((column % 4) * this.tagSpaceBetweenX);
          tagContainer.position.y = ((row % 4) * tagBg.height) + ((row % 4) * this.tagSpaceBetweenY);

          // copy original position to a variable for later
          tagContainer.originalPosition = new PIXI.Point().copyFrom(tagContainer.position);

          // tag text
          const tagTextEN = this.createInterfaceText(this.data.tags[tagIndex].text["en"], {...this.tagTextStyle}, "en"); // use a copy of the baseButtonTextStyle so we can update them individually
          const tagTextFR = this.createInterfaceText(this.data.tags[tagIndex].text["fr"], {...this.tagTextStyle}, "fr"); // use a copy of the baseButtonTextStyle so we can update them individually
          tagTextEN.anchor.set(0.5); // center in box easier
          tagTextFR.anchor.set(0.5); // center in box easier
          tagTextEN.position.x = tagContainer.width / 2;
          tagTextFR.position.x = tagContainer.width / 2;
          tagTextEN.position.y = tagContainer.height / 2;
          tagTextFR.position.y = tagContainer.height / 2;
          tagContainer.addChild(tagTextEN);
          tagContainer.addChild(tagTextFR);

          // tag events
          tagContainer.on("pointerdown", (e) => {
            // save the target so we can keep "this" scope
            this.dragTarget = e.currentTarget;
            this.handleOnDragStart(e);
          }).on("pointerup", (e) => {
            this.handleOnDragEnd(e);
          }).on("pointerupoutside", (e) => {
            this.handleOnDragEnd(e);
          });

          // create the related dropzone too
          let tagDropZoneContainer = new PIXI.Container();
          let tagDropZone = new PIXI.Sprite(PIXI.Texture.WHITE);
          tagDropZone.tint = 0xFFFFFF;
          tagDropZone.anchor.set(0.5);
          tagDropZone.width = this.data.tags[tagIndex].dropZone.width;
          tagDropZone.height = this.data.tags[tagIndex].dropZone.height;
          tagDropZoneContainer.position.x = this.data.tags[tagIndex].dropZone.x;
          tagDropZoneContainer.position.y = this.data.tags[tagIndex].dropZone.y;
          tagDropZoneContainer.addChild(tagDropZone);

          let tagDropZoneBorder = new PIXI.Graphics();
          tagDropZoneBorder.rect(-tagDropZone.width/2, tagDropZone.height/2 - 2, tagDropZone.width, 2);
          tagDropZoneBorder.fill(0x000000);
          tagDropZoneContainer.addChild(tagDropZoneBorder);

          // keep references for later
          tagContainer.targetDropZone = tagDropZone;
          tagContainer.background = tagBg;
          tagContainer.textEN = tagTextEN;
          tagContainer.textFR = tagTextFR;

          this.sentenceTextContainer.addChild(tagDropZoneContainer);
          this.tagsContainer.addChild(tagContainer);
          this.tagsObjects.push(tagContainer);
          tagIndex++;
        }
      }
    }

    // position the tags container when the width is known
    this.tagsContainer.position.x = this.appWidth / 2 - this.tagsContainer.width / 2;
  }

  handleOnDragStart(e) {
    this.dragTarget.alpha = 0.5;
    const clickPos = this.dragTarget.parent.toLocal(e.global, null);

    // place tag on mouse
    gsap.to(this.dragTarget.position, {
      x: clickPos.x - this.dragTarget.width / 2,
      y: clickPos.y - this.dragTarget.height / 2,
      duration: 0.05
    });

    this.stage.eventMode = 'static';
    this.stage.on("pointermove", (e) => {
      this.handleOnDrag(e);
    });
  }

  handleOnDrag(e) {
    if (this.dragTarget) {
      const clickPos = this.dragTarget.parent.toLocal(e.global, null);

      // Check if element is inside the background container
      if (
        (e.globalX >= this.sentenceTextContainer.position.x) &&
        (e.globalX <= this.sentenceTextContainer.position.x + this.sentenceTextContainer.width) &&
        (e.globalY >= this.sentenceTextContainer.position.y) &&
        (e.globalY <= this.sentenceTextContainer.position.y + this.sentenceTextContainer.height)
      ) {
        // Scale down the element
        this.dragTarget.width = this.tagWidth * 0.55;
        this.dragTarget.height = this.tagHeight * 0.55;
      } else {
        // Scale back the element
        this.dragTarget.width = this.tagWidth;
        this.dragTarget.height = this.tagHeight;
      }

      // tag follow mouse
      gsap.killTweensOf(this.dragTarget.position);
      gsap.to(this.dragTarget.position, {
        x: clickPos.x - this.dragTarget.width / 2,
        y: clickPos.y - this.dragTarget.height / 2,
        duration: 0.05
      });
    }
  }

  handleOnDragEnd(e) {
    if (this.dragTarget) {
      this.stage.eventMode = 'auto';
      this.stage.off("pointermove");

      // Reset tag
      this.dragTarget.alpha = 1;

      // Check if we landed on the related dropzone or not
      let success = this.checkDropZone(e.global, this.dragTarget);

      if (success) {
        this.foundAnswers++;

        // disable drag for that object
        this.dragTarget.eventMode = "none";

        // move the tag to this position
        gsap.killTweensOf(this.dragTarget.position);
        gsap.to(this.dragTarget, {
          alpha: 0.0,
          duration: 0.25
        });

        // show the real answer behind the dropzone
        gsap.to(this.dragTarget.targetDropZone.parent, {
          alpha: 0.0,
          duration: 0.25,
        });

        // we went through all the questions, go to end
        if (this.foundAnswers >= this.data.tags.length) {
          setTimeout(() => {
            this.complete();
          }, 1000);
          return;
        }
      } else {
        // Reset tag
        this.dragTarget.width = this.tagWidth;
        this.dragTarget.height = this.tagHeight;

        // reset position
        gsap.killTweensOf(this.dragTarget.position);
        gsap.to(this.dragTarget.position, {
          x: this.dragTarget.originalPosition.x,
          y: this.dragTarget.originalPosition.y,
          duration: 0.25
        })
      }

      this.dragTarget = false;
    }
  }

  checkDropZone(cursorPos, tag) {
    const dropPos = this.sentenceTextContainer.toLocal(cursorPos, null);
    const dropZoneContainerPos = tag.targetDropZone.parent.position;

    if (
      (dropPos.x >= (dropZoneContainerPos.x - tag.targetDropZone.width / 2)) &&
      (dropPos.x <= (dropZoneContainerPos.x + tag.targetDropZone.width / 2)) &&
      (dropPos.y >= (dropZoneContainerPos.y - tag.targetDropZone.height / 2)) &&
      (dropPos.y <= (dropZoneContainerPos.y + tag.targetDropZone.height / 2))
    ) {
     return true;
    }

    return false;
  }

  /**
   * Language switcher for interface text
   * Show/Hide using language
   * @param lang
   */
  interfaceLanguageSwitch(lang) {
    const textShownArray = lang === "fr" ? this.interfaceTextFR : this.interfaceTextEN;
    const textHiddenArray = lang === "fr" ? this.interfaceTextEN : this.interfaceTextFR;

    // Update hidden
    textHiddenArray.forEach(text => text.alpha = 0.0);

    // Update shown
    textShownArray.forEach(text => text.alpha = 1.0);

    // TODO: Update height and all positions based on new language
    if (lang === "en") {
      //this.sentenceBackgroundSprite.height = this.sentenceTextEN.height + (this.textPadding * 2)
    } else if (lang === "fr") {
      //this.sentenceBackgroundSprite.height = this.sentenceTextFR.height + (this.textPadding * 2)
    }
  }

  reset() {
    //console.log("gameF Reset");
    // TODO: There's more things to reset

    this.currentQuestion = -1;
    this.foundAnswers = 0;
    this.isCheckingAnswer = false;

    for (let i = 0; i < this.tagsObjects.length; i++) {
      // save the original GLOBAL position after the parent container is placed, for later use
      this.tagsObjects[i].eventMode = "static";
      this.tagsObjects[i].alpha = 1.0;
      this.tagsObjects[i].targetDropZone.parent.alpha = 1.0;
      this.tagsObjects[i].width = this.tagWidth;
      this.tagsObjects[i].height = this.tagHeight;
      this.tagsObjects[i].position.copyFrom(this.tagsObjects[i].originalPosition);
    }
  }
}
